module.exports = __webpack_public_path__ + "static/media/ten_types_human.3a4db7eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/ten_types_human.jpg
// module id = 123
// module chunks = 0